// src/services/onboardingService.js
import axios from "axios";
import { onboardingUrl , confirmOnboarding , paymentOnboardingInitiate , verifyOnboardingPayment} from "src/react-query/endPoints";

async function submitOnboarding(payload) {
  return await axios.post(onboardingUrl(), payload);
}

async function resendVerificationEmail(payload) {
  return await axios.post(resendVerificationEmail(), payload);
}

async function confirmOnboardingEmail(token){
  return await axios.get(confirmOnboarding(token));
}

async function initiatePaymentOnboarding(payload) {
  return await axios.post(paymentOnboardingInitiate(), payload);
}

async function verifyPaymentOnboarding(payload) {
  return await axios.post(verifyOnboardingPayment(), payload);
}



const onboardingService = {
  submitOnboarding,
  confirmOnboardingEmail,
  initiatePaymentOnboarding,
  verifyPaymentOnboarding,
  resendVerificationEmail
};

export default onboardingService;